import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'

import {
  LeaderApprovalModal,
  AssessorApprovalModal,
  AlreadyAssessedModal
} from 'components/modals'
import { RPSubHeader, RPToasts } from 'components/sections/dashboard'
import { DashboardGrid as Grid } from 'components/layout'
import { ACTIVITY_STATES, ACTIVITY_SECTIONS, CONFIGURATION_KEYS } from 'constants/enums'
import MODALS from 'constants/layout/modals'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import { modal } from 'helpers/decorators'
import { apiConfiguration, apiDashboard } from 'helpers/decorators/api'
import { renderRoutes } from 'react-router-config'
import config from 'config'
import { connect } from 'react-redux'
import { isAssessorManagementEnabledForActivity } from '../../../helpers/assessorHelper'

@modal.trigger()
@apiDashboard.apiResidentialProject({
  loaders: ['approval']
})
@apiConfiguration()
@connect(
  ({ api }) => ({
    award: api.awards.data
  }),
  {}
)
class ResidentialProject extends Component {
  static propTypes = {
    onSendAssessmentRequest: PropTypes.func.isRequired,
    onSendAlreadyAssessed: PropTypes.func.isRequired,
    onSendLeaderRequest: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    approvalStatus: PropTypes.object,
    params: PropTypes.object,
    route: PropTypes.object,
    onGetConfigurationValue: PropTypes.func,
    awards: PropTypes.object
  }

  componentWillMount = async () => {
    const orgId = get(this.props, 'awards.data.organization.id')

    orgId && await this.props.onGetConfigurationValue(CONFIGURATION_KEYS.isAssessorManagementEnabled.id, orgId, true)
  }

  handleSendLeaderRequest = (fields, { resetForm }) =>
    this.props.onSendLeaderRequest(get(this.props.params, 'rPId'), fields, {
      resetForm
    })

  handleSendAlreadyAssessed = (fields, { resetForm }) =>
    this.props.onSendAlreadyAssessed(get(this.props.params, 'rPId'), fields, {
      resetForm
    })

  handleSendAssessmentRequest = (fields, { resetForm }) =>
    this.props.onSendAssessmentRequest(get(this.props.params, 'rPId'), fields, {
      resetForm
    })

  handleOpenAssessorApproval = () =>
    setTimeout(() => this.props.onOpen(MODALS.SEND_RP_ASSESSOR_APPROVAL), 400)

  handleOpenLeaderApproval = () =>
    this.props.onOpen(MODALS.SEND_RP_LEADER_APPROVAL)

  handleOpenAlreadyAssessed = () => {
    this.props.onClose()
    setTimeout(() => {
      this.props.onOpen(MODALS.SEND_RP_ALREADY_ASSESSED, null, null)
    }, 500)
  }

  render() {
    const { awards, route, params, approvalStatus } = this.props

    const residentialProject = get(awards, 'data.residentialProject')
    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(residentialProject)
    const rPState = get(residentialProject, 'state.value')
    const assessorEmail = get(residentialProject, 'assessorEmail')
    const colorClass = getActivityClassName(
      ACTIVITY_SECTIONS.residential_project.id
    )

    const progressArr = [
      Boolean(rPState !== ACTIVITY_STATES.setup.id),
      [
        ACTIVITY_STATES.complete.id,
        ACTIVITY_STATES.ceremony.id,
        ACTIVITY_STATES.office_signoff.id
      ].includes(rPState)
    ]

    const completedCount = progressArr.filter(item => item).length.toString()

    return (
      <Grid.RightOuter>
        <RPSubHeader
          activityRoute={`${config.publicPath}/dashboard/awards/${params.awardId}/residential-project/${params.rPId}`}
          progressArr={progressArr}
          title={
            <FormattedMessage
              id="moduleTitle.residential_project"
              defaultMessage="Residential project"
            />
          }
          subtitle={
            <FormattedMessage
              id="moduleTitle.completed_progress"
              defaultMessage={`Completed ${completedCount} / 2`}
              values={{
                finished: completedCount,
                total: '2'
              }}
            />
          }
          rPState={rPState}
        />

        {route && renderRoutes(route.routes, {
          colorClass,
          params,
          residentialProject,
          onOpenAssessorApproval: this.handleOpenAssessorApproval,
          onOpenLeaderApproval: this.handleOpenLeaderApproval
        })}

        <RPToasts
          onOpenAssessorApproval={this.handleOpenAssessorApproval}
          onOpenLeaderApproval={this.handleOpenLeaderApproval}
          residentialProject={residentialProject}
        />

        <AssessorApprovalModal
          modalId={MODALS.SEND_RP_ASSESSOR_APPROVAL}
          onOpenAlreadyAssessed={this.handleOpenAlreadyAssessed}
          onSubmit={this.handleSendAssessmentRequest}
          colorClass={colorClass}
          loading={get(approvalStatus, 'loading')}
          noAssessor={!assessorEmail}
          isAssessorManagementEnabled={isAssessorManagementEnabled}
        />

        <LeaderApprovalModal
          modalId={MODALS.SEND_RP_LEADER_APPROVAL}
          onSubmit={this.handleSendLeaderRequest}
          colorClass={colorClass}
          loading={get(approvalStatus, 'loading')}
        />

        <AlreadyAssessedModal
          modalId={MODALS.SEND_RP_ALREADY_ASSESSED}
          onSubmit={this.handleSendAlreadyAssessed}
          colorClass={colorClass}
          loading={get(approvalStatus, 'loading')}
        />
      </Grid.RightOuter>
    )
  }
}

export default ResidentialProject
